import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';

function ComSwitch({
  children,
  className = '',
  size = 'default',
  defaultChecked = false,
  checked,
  loading,
  onSwitchChange,
  ...props
}) {
  return (
    <Switch
      className={`com-switch ${className}`}
      size={size}
      loading={loading}
      checked={checked}
      defaultChecked={defaultChecked === true}
      onChange={onSwitchChange}
      {...props}
    >
      {children}
    </Switch>
  );
}

ComSwitch.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  loading: PropTypes.bool,
  onSwitchChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['default', 'small']),
};

export default ComSwitch;
